import axios from 'axios'
import { isAddressNative } from '../utils'
import { NetworkType } from '..'
// const PATH_FINDER_ENDPOINT = 'https://api.pathfinder.routerprotocol.com/api/getRouteForMultiSwap'
const PATH_FINDER_API_URL = "https://api.pathfinder.routerprotocol.com/api"


// calling the pathfinder api using axios
const fetchPathfinderData = async (params: any) => {
    const endpoint = "quote"
    const pathUrl = `${PATH_FINDER_API_URL}/${endpoint}`
    try {
        const res = await axios.get(pathUrl, { params })
        return res.data
    } catch (e) {
        console.error(`Fetching data from pathfinder: ${e}`)
    }
}
const getSwapQuote = async ({ 
     expandedAmount,
     sourceNetworkId,
     destinationNetworkId,
     sourceTokenAddress,
     destinationTokenAddress,
    userAddress,
    feeTokenAddress,
    slippageTolerance,
    network_config,
    widgetId }:
    { 
         expandedAmount: string,
         sourceNetworkId: string,
         destinationNetworkId: string,
         sourceTokenAddress: string,
         destinationTokenAddress: string,
         userAddress:string,
        feeTokenAddress:string,
        widgetId:string,
        slippageTolerance:number,
        network_config:{ [chainId: string]: NetworkType }
    }
) => {
    let args;
    if(sourceNetworkId===destinationNetworkId){
        args={
            'fromTokenAddress': sourceTokenAddress, // USDC on Polygon
            'toTokenAddress': destinationTokenAddress, // USDC on Fantom
            'amount': expandedAmount, // 10 USDC (USDC token contract on Polygon has 6 decimal places)
            'fromTokenChainId': sourceNetworkId, // Polygon
            'toTokenChainId': destinationNetworkId, // Fantom
            'userAddress': userAddress,
            'slippageTolerance': slippageTolerance,
            widgetId
        }
        // pathUrl = `${PATH_FINDER_ENDPOINT}?fromTokenAddress=${sourceTokenAddress}&toTokenAddress=${destinationTokenAddress}&amount=${expandedAmount}&fromTokenChainId=${sourceNetworkId}&toTokenChainId=${destinationNetworkId}`
    } else {
        if(isAddressNative(sourceTokenAddress,sourceNetworkId)||isAddressNative(destinationTokenAddress,destinationNetworkId)){
            // pathUrl = `${PATH_FINDER_ENDPOINT}?fromTokenAddress=${network_config[sourceNetworkId].wnative}&toTokenAddress=${destinationTokenAddress}&amount=${expandedAmount}&fromTokenChainId=${sourceNetworkId}&toTokenChainId=${destinationNetworkId}`
            args={
                'fromTokenAddress': network_config[sourceNetworkId].wnative, // USDC on Polygon
                'toTokenAddress': network_config[destinationNetworkId].wnative, // USDC on Fantom
                'amount': expandedAmount, // 10 USDC (USDC token contract on Polygon has 6 decimal places)
                'fromTokenChainId': sourceNetworkId, // Polygon
                'toTokenChainId': destinationNetworkId, // Fantom
                'userAddress': userAddress,
                'feeTokenAddress': feeTokenAddress, // ROUTE on Polygon
                'slippageTolerance': slippageTolerance,
                widgetId
            }
        }else if(isAddressNative(sourceTokenAddress,sourceNetworkId)){
            // pathUrl = `${PATH_FINDER_ENDPOINT}?fromTokenAddress=${network_config[sourceNetworkId].wnative}&toTokenAddress=${destinationTokenAddress}&amount=${expandedAmount}&fromTokenChainId=${sourceNetworkId}&toTokenChainId=${destinationNetworkId}`
            args={
                'fromTokenAddress': network_config[sourceNetworkId].wnative, // USDC on Polygon
                'toTokenAddress': destinationTokenAddress, // USDC on Fantom
                'amount': expandedAmount, // 10 USDC (USDC token contract on Polygon has 6 decimal places)
                'fromTokenChainId': sourceNetworkId, // Polygon
                'toTokenChainId': destinationNetworkId, // Fantom
                'userAddress': userAddress,
                'feeTokenAddress': feeTokenAddress, // ROUTE on Polygon
                'slippageTolerance': slippageTolerance,
                widgetId
            }
        }else if(isAddressNative(destinationTokenAddress,destinationNetworkId)){
            // pathUrl = `${PATH_FINDER_ENDPOINT}?fromTokenAddress=${sourceTokenAddress}&toTokenAddress=${network_config[destinationNetworkId].wnative}&amount=${expandedAmount}&fromTokenChainId=${sourceNetworkId}&toTokenChainId=${destinationNetworkId}`
            args={
                'fromTokenAddress': sourceTokenAddress, // USDC on Polygon
                'toTokenAddress': network_config[destinationNetworkId].wnative, // USDC on Fantom
                'amount': expandedAmount, // 10 USDC (USDC token contract on Polygon has 6 decimal places)
                'fromTokenChainId': sourceNetworkId, // Polygon
                'toTokenChainId': destinationNetworkId, // Fantom
                'userAddress': userAddress,
                'feeTokenAddress': feeTokenAddress, // ROUTE on Polygon
                'slippageTolerance': slippageTolerance,
                widgetId
            }
        } else{
            // pathUrl = `${PATH_FINDER_ENDPOINT}?fromTokenAddress=${sourceTokenAddress}&toTokenAddress=${destinationTokenAddress}&amount=${expandedAmount}&fromTokenChainId=${sourceNetworkId}&toTokenChainId=${destinationNetworkId}`
            args={
                'fromTokenAddress': sourceTokenAddress, // USDC on Polygon
                'toTokenAddress': destinationTokenAddress, // USDC on Fantom
                'amount': expandedAmount, // 10 USDC (USDC token contract on Polygon has 6 decimal places)
                'fromTokenChainId': sourceNetworkId, // Polygon
                'toTokenChainId': destinationNetworkId, // Fantom
                'userAddress': userAddress,
                'feeTokenAddress': feeTokenAddress, // ROUTE on Polygon
                'slippageTolerance': slippageTolerance,
                widgetId
            }
        }
    }

    try {
        if(args){
            const pathfinder_response = await fetchPathfinderData(args)
            return pathfinder_response;
        }
    } catch (e) {
        return e
    }
}

export default getSwapQuote